import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';

import { IWizardOptions } from '../../../models';
import * as DateTypes from 'common-lib';

import moment_ from 'moment';
const moment = moment_;

/**
 * Date Range's values are determined by Wizard DefaultOptions
 */
@Component({
    selector: 'wizard-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['../../form-styles.scss']
})
export class DateRangeComponent extends BaseComponent implements OnInit {
    public dateRange: DateTypes.DateRange = {
        start: moment().format(),
        end: moment().format(),
        type: DateTypes.FixedDatesDateRangeType
    };
    private dateStart: moment.Moment = undefined;
    private dateEnd: moment.Moment = undefined;
    private subscription: Subscription;
    public quickDates = [
        {
            name: 'Tomorrow',
            value: 'Tomorrow'
        },
        {
            name: 'Next Week',
            value: 'Next Week'
        },
        {
            name: 'Next Two Weeks',
            value: 'Next Two Weeks'
        },
        {
            name: 'In Two Weeks',
            value: 'In Two Weeks'
        },
        {
            name: 'This Month',
            value: 'This Month'
        },
        {
            name: 'Next Month',
            value: 'Next Month'
        }
    ];
    @Output() onUpdateDateRangeMode = new EventEmitter<DateTypes.DateRangeMode>();

    constructor(public wizardService: WizardService, private eventService: EventService) {
        super();
    }

    ngOnInit() {
        this.setDefaultDateRangesIfExists();
        this.subscribeToMeetingDefaultsUpdates();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private subscribeToMeetingDefaultsUpdates() {
        this.subscription = this.wizardService.onNewDefaultOptions$.subscribe((defaults: IWizardOptions) => {
            if (defaults) {
                this.updateDefaultDateRange({ dateStart: defaults.dateStart, dateEnd: defaults.dateEnd });
            }
        });

        const quickDatesSubscription = this.wizardService.quickDates$.subscribe((quickDates) => {
            if (quickDates?.start) {
                this.updateDefaultDateRange({ dateStart: quickDates.start, dateEnd: quickDates.end });
            }
        });

        this.subscription.add(quickDatesSubscription);
    }

    private setDefaultDateRangesIfExists() {
        if (this.wizardService.options.dateStart) {
            this.updateDefaultDateRange({
                dateStart: this.wizardService.options.dateStart,
                dateEnd: this.wizardService.options.dateEnd
            });
        }
    }

    private updateDefaultDateRange(dates: { dateStart: moment.Moment; dateEnd: moment.Moment }) {
        this.dateRange = {
            start: dates.dateStart.format(),
            end: dates.dateEnd.format(),
            type: DateTypes.FixedDatesDateRangeType
        };

        this.updateDateStartEnd(dates);
    }

    private updateDateStartEnd(dates: { dateStart: moment.Moment; dateEnd: moment.Moment }) {
        this.dateStart = dates.dateStart || this.dateStart;
        this.dateEnd = dates.dateEnd || this.dateEnd;

        if (dates.dateStart) {
            this.wizardService.updateOptions({ dateStart: this.dateStart });
        }

        if (dates.dateEnd) {
            this.wizardService.updateOptions({ dateEnd: this.dateEnd });
        }

        this.eventService.clearErrorMessage('availability');
    }

    public handleUpdateDateRange(dateRange: DateTypes.DateRange) {
        if (dateRange.type === DateTypes.FixedDatesDateRangeType) {
            this.updateDateStartEnd({
                dateStart: moment(dateRange.start),
                dateEnd: moment(dateRange.end)
            });
        }
    }

    public handleUpdateDateRangeMode(dateRangeMode: DateTypes.DateRangeMode) {
        this.onUpdateDateRangeMode.emit(dateRangeMode);
    }
}
